import React from 'react';
import PropTypes from 'prop-types';
import reactCSS from 'reactcss';
import { SketchPicker } from 'react-color';
import _ from 'lodash';

const isValidHex = (value) => {
  // ------ Test value is a hex color -------
  const regEx = /^#?[A-Fa-f0-9]{3}([A-Fa-f0-9]{3})?$/;
  return (regEx.test(value));
};

class ColorPicker extends React.Component {
  static propTypes = {
    // Ant provides this (getFieldDecorator), and it cant have a default, nor be required
    // eslint-disable-next-line react/require-default-props
    value: PropTypes.string,
    editable: PropTypes.bool,
    valueIfEmpty: PropTypes.string, // Default color if no value has been provided. Defaults to #000
    onChange: PropTypes.func // Change event
  };

  static defaultProps = {
    editable: true,
    valueIfEmpty: '#000',
    onChange() {
    }
  };

  constructor(props) {
    super(props);

    const color = this.getValueIfEmpty(props.value);
    this.state = {
      color,
      displayColorPicker: false
    };

    this.handleChangeComplete = this.handleChangeComplete.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  getValueIfEmpty(value) {
    const { valueIfEmpty } = this.props;

    // -- If current value is empty or not a valid hex color
    // -- then use the color set for valueIfEmpty.
    // ---
    if (_.isEmpty(value) || !isValidHex(value)) {
      // -- If valueIfEmpty is not a valid hex color, then
      // -- return #000 as the default color, otherwise
      // -- return the color set for valueIfEmpty.
      // ---
      return (isValidHex(valueIfEmpty) ? valueIfEmpty : '#000');
    }
    return value;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const color = this.getValueIfEmpty(nextProps.value);
    this.setState({ color });
  }

  handleChangeComplete(nextColor) {
    const { onChange } = this.props;
    this.setState({ color: nextColor.hex });
    onChange(nextColor.hex);
  }

  handleClick() {
    const { editable } = this.props;
    const { displayColorPicker } = this.state;
    this.setState({
      displayColorPicker: editable && !displayColorPicker
    });
  }

  handleClose() {
    this.setState({
      displayColorPicker: false
    });
  }

  render() {
    const { color, displayColorPicker } = this.state;
    const { editable } = this.props;

    const styles = reactCSS({
      default: {
        swatch: {
          display: 'inline-block',
          width: '100px',
          height: '32px',
          padding: '5px',
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: 'rgb(217, 217, 217)',
          borderRadius: '4px',
          cursor: (editable ? 'pointer' : 'default')
        },
        color: {
          width: '100%',
          height: '100%',
          borderRadius: '4px',
          background: color
        },
        popover: {
          position: 'absolute',
          zIndex: '2'
        },
        cover: {
          position: 'fixed',
          top: '0px',
          right: '0px',
          bottom: '0px',
          left: '0px'
        }
      }
    });

    return (
      <div>
        <div style={styles.swatch} onClick={this.handleClick}>
          <div style={styles.color} />
        </div>
        {displayColorPicker && (
          <div style={styles.popover}>
            <div style={styles.cover} onClick={this.handleClose} />
            <SketchPicker color={color} onChangeComplete={this.handleChangeComplete} />
          </div>
        )}
      </div>
    );
  }
}

export default ColorPicker;
